import type { ReactNode } from 'react';

import { classNames } from '../design/components/classNames';

export interface HeaderBarProps {
  /** Logo links in der grünen Leiste, meist ein Link zur Startseite (siehe `HeaderBrandContent`). */
  marke: ReactNode;
  /** Mitte der grünen Leiste, z. B. der Name des Portals (`.ksb-header__name`). Auf dem Smartphone ausgeblendet. */
  mitte?: ReactNode;
  /** Rechts in der grünen Leiste: Benutzer, Abmelden. */
  werkzeuge?: ReactNode;
  /** Zweite Leiste in Schwarzwald: die Navigation. */
  children?: ReactNode;
  /** Ohne Höchstbreite und mit schmalem Rand, damit sie mit der Seitenleiste der Verwaltung fluchtet. */
  breit?: boolean;
}

/**
 * Die Kopfzeile in zwei Leisten nach dem Kopf der KSB-Seite vom Marketing: oben Grün mit Logo, Name und Werkzeugen,
 * darunter Schwarzwald mit der Navigation. Klebend. Gestaltet in `design/shell.css`.
 */
export function HeaderBar({ marke, mitte, werkzeuge, children, breit = false }: HeaderBarProps) {
  return (
    <header className={classNames('ksb-header ksb-on-dark', breit && 'ksb-header--breit')}>
      <div className="ksb-header__top">
        <div className="ksb-header__bar">
          {marke}
          <span className="ksb-header__titel">{mitte}</span>
          <div className="ksb-header__tools">{werkzeuge}</div>
        </div>
      </div>
      {Boolean(children) && (
        <div className="ksb-header__navrow">
          <div className="ksb-header__bar">{children}</div>
        </div>
      )}
    </header>
  );
}

/**
 * Das Wortlogo. Es ist hier Schmuck (`alt=""`); der Link darum herum trägt den zugänglichen Namen. Das Logo ist laut Paket
 * immer weiß auf dem grünen Feld und wird nicht umgefärbt (`app/public/brand/ksb-logo-primary.png`). Das Feld hat dasselbe
 * Grün wie die obere Leiste und verschmilzt mit ihr.
 */
export function HeaderBrandContent() {
  return (
    <img
      className="ksb-header__logo"
      src="/brand/ksb-logo-primary.png"
      alt=""
      width={114}
      height={52}
    />
  );
}
